export default __webpack_public_path__ + "static/media/Traci_DeForge_AHV_In_Moms_We_Trust.f06a8509.jpg";